import { createAction } from '../../../utils/actions';

export const LESSON_START_UPDATE = 'LESSON_START_UPDATE';
export const LESSON_START_VALUE_CHANGED = 'LESSON_START_VALUE_CHANGED';

export const postStartChange = (lessonId, data) => (dispatch, getState, container) => {
    if (!lessonId || !lessonId.lessonID) {
        return Promise.reject(new Error('Invalid lesson ID'));
    }

    if (!data || !data.new || !data.reason) {
        return Promise.reject(new Error('Missing required fields'));
    }

    const promise = container().api.courses.changeLessonStart(lessonId, data);
    return dispatch(createAction(LESSON_START_UPDATE, promise));
};



// WEBPACK FOOTER //
// ./src/incab/common/LessonStartForm/actions.js